/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetSelfEmploymentResponse } from './AssetSelfEmploymentResponse';
import {
    AssetSelfEmploymentResponseFromJSON,
    AssetSelfEmploymentResponseFromJSONTyped,
    AssetSelfEmploymentResponseToJSON,
    AssetSelfEmploymentResponseToJSONTyped,
} from './AssetSelfEmploymentResponse';
import type { AssetIncomeResponse } from './AssetIncomeResponse';
import {
    AssetIncomeResponseFromJSON,
    AssetIncomeResponseFromJSONTyped,
    AssetIncomeResponseToJSON,
    AssetIncomeResponseToJSONTyped,
} from './AssetIncomeResponse';
import type { SeizableIncomeAssessmentResponse } from './SeizableIncomeAssessmentResponse';
import {
    SeizableIncomeAssessmentResponseFromJSON,
    SeizableIncomeAssessmentResponseFromJSONTyped,
    SeizableIncomeAssessmentResponseToJSON,
    SeizableIncomeAssessmentResponseToJSONTyped,
} from './SeizableIncomeAssessmentResponse';

/**
 * 
 * @export
 * @interface AssetIncomeTabResponse
 */
export interface AssetIncomeTabResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {AssetSelfEmploymentResponse}
     * @memberof AssetIncomeTabResponse
     */
    selfEmployment: AssetSelfEmploymentResponse;
    /**
     * 
     * @type {Array<AssetIncomeResponse>}
     * @memberof AssetIncomeTabResponse
     */
    incomes: Array<AssetIncomeResponse>;
    /**
     * 
     * @type {SeizableIncomeAssessmentResponse}
     * @memberof AssetIncomeTabResponse
     */
    assessment: SeizableIncomeAssessmentResponse;
}

/**
 * Check if a given object implements the AssetIncomeTabResponse interface.
 */
export function instanceOfAssetIncomeTabResponse(value: object): value is AssetIncomeTabResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('selfEmployment' in value) || value['selfEmployment'] === undefined) return false;
    if (!('incomes' in value) || value['incomes'] === undefined) return false;
    if (!('assessment' in value) || value['assessment'] === undefined) return false;
    return true;
}

export function AssetIncomeTabResponseFromJSON(json: any): AssetIncomeTabResponse {
    return AssetIncomeTabResponseFromJSONTyped(json, false);
}

export function AssetIncomeTabResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetIncomeTabResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'selfEmployment': AssetSelfEmploymentResponseFromJSON(json['selfEmployment']),
        'incomes': ((json['incomes'] as Array<any>).map(AssetIncomeResponseFromJSON)),
        'assessment': SeizableIncomeAssessmentResponseFromJSON(json['assessment']),
    };
}

export function AssetIncomeTabResponseToJSON(json: any): AssetIncomeTabResponse {
    return AssetIncomeTabResponseToJSONTyped(json, false);
}

export function AssetIncomeTabResponseToJSONTyped(value?: AssetIncomeTabResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'selfEmployment': AssetSelfEmploymentResponseToJSON(value['selfEmployment']),
        'incomes': ((value['incomes'] as Array<any>).map(AssetIncomeResponseToJSON)),
        'assessment': SeizableIncomeAssessmentResponseToJSON(value['assessment']),
    };
}

